import { Typography } from "@mui/material";
import { format } from "date-fns";
import "./taskListGroupLabelStyle.css"

export function TaskListGroupLabel(props: { label: string, date: Date }) {
  return <Typography className="List_Group_Label">{`${props.label}, ${format(props.date, "MMMM do")}`}</Typography>
}